import React from 'react';
import { isDocumentImage } from '@/utils/documents';
import clsx from 'clsx';
import UserSquareIcon from '@/assets/icons/UserSquare';
import CalendarDots from '@/assets/icons/CalendarDots';
import TagIcon from '@/assets/icons/TagIcon';
import { formatNorwegianDate } from '@/utils/dates';
import { ChevronRight, Download } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const DocumentListItem = ({ classes, document, docPath, downloadEnabled }) => {
  const createdDateText = formatNorwegianDate(document?.createdDate);
  return (
    <Link
      to={`${docPath}/${document.id}`}
      className={clsx(['flex items-center gap-3 w-full', classes])}
    >
      <div className="flex items-center justify-center border rounded-lg bg-white min-w-[40px] md:min-w-[60px] max-w-[40px] md:max-w-[60px] h-[40px] md:h-[60px] overflow-hidden">
        {isDocumentImage(document) ? (
          <img alt="doc" src={document.url.link} />
        ) : (
          <p className="uppercase text-[12px] md:text-sm font-bold text-primary p-1">
            .{document.url.fileType}
          </p>
        )}
      </div>
      <div className="flex justify-between w-full max-w-[calc(100%-72px)]">
        <div className="flex flex-col items-start gap-2 max-w-[calc(100%-50px)] overflow-hidden">
          <p className="text-sm md:text-base font-medium whitespace-nowrap text-foreground max-w-full overflow-hidden text-ellipsis">
            {document.title}
          </p>
          <div className="flex flex-wrap gap-1 md:gap-4 text-base text-sm md:text-[15px] leading-[15px]">
            <div className="flex items-center gap-1">
              <CalendarDots />
              <p className="opacity-65">{createdDateText}</p>
            </div>
            <div className="hidden md:flex items-center gap-1">
              <TagIcon />
              <p className="opacity-65">{document.documentType}</p>
            </div>
            <div className="flex items-center gap-1">
              <UserSquareIcon />
              <p className="opacity-65">
                {document.ownedByName || document.companyName}
              </p>
            </div>
          </div>
        </div>
        <div className="hidden md:flex items-center gap-1">
          {downloadEnabled && (
            <Button
              className="text-foreground"
              variant="link"
              aria-label="Download document"
              onClick={() => {
                window.open(document.url.link, '_blank', 'noopener,noreferrer');
              }}
            >
              <Download width={17} />
            </Button>
          )}
          <Button className="text-foreground" variant="link">
            <ChevronRight width={17} />
          </Button>
        </div>
      </div>
    </Link>
  );
};

export default DocumentListItem;
